import { motion } from "framer-motion";
import { Quote, Star } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";

const meta = [
  { initial: "S", author: "Sarah, 32", color: "from-blue-500 to-cyan-500" },
  { initial: "M", author: "Marc, 28", color: "from-violet-500 to-fuchsia-500" },
  { initial: "L", author: "Léa, 26", color: "from-pink-500 to-rose-500" },
];

export const Testimonials = () => {
  const { t } = useLang();
  return (
    <section
      id="temoignages"
      data-testid="testimonials-section"
      className="relative py-24 sm:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-emerald-400">
            {t.testimonials.overline}
          </span>
          <h2 className="mt-4 font-outfit text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-white">
            {t.testimonials.title}
          </h2>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-6">
          {t.testimonials.items.map((item, i) => {
            const m = meta[i];
            return (
              <motion.div
                key={i}
                data-testid={`testimonial-${i}`}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                className="flex flex-col rounded-2xl border border-white/10 bg-white/[0.03] p-8"
              >
                <div className="flex text-emerald-400">
                  {[...Array(5)].map((_, s) => (
                    <Star key={s} className="h-4 w-4 fill-current" />
                  ))}
                </div>
                <Quote className="mt-4 h-7 w-7 text-white/15" />
                <p className="mt-3 flex-1 text-slate-200 leading-relaxed">« {item.quote} »</p>
                <div className="mt-6 flex items-center gap-3">
                  <span className={`grid place-items-center h-11 w-11 rounded-full bg-gradient-to-br ${m.color} font-bold text-white`}>
                    {m.initial}
                  </span>
                  <div>
                    <p className="font-bold text-white">{m.author}</p>
                    <p className="text-sm text-emerald-300">{item.role}</p>
                  </div>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
